























import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class DateEditor extends Vue {
    @Prop({ default: new Date() }) value?: Date;

    get year() { return this.value ? this.value.getFullYear() : 0 ; }
    get month() { return this.value ? this.value.getMonth() + 1 : 0; }
    get date() { return this.value ? this.value.getDate() : 0; }

    updateYear(year: number) {
        if(year > 0) {
            const nd = new Date(this.value ? this.value.valueOf() : 0);
            nd.setFullYear(year);
            this.$emit('input', nd);
        }
    }

    updateMonth(month: number) {
        if(month > 0) {
            const nd = new Date(this.value ? this.value.valueOf() : 0);
            nd.setMonth(month - 1);
            this.$emit('input', nd);
        }
    }

    updateDate(date: number) {
        if(date > 0) {
            const nd = new Date(this.value ? this.value.valueOf() : 0);
            nd.setDate(date);
            this.$emit('input', nd);
        }
    }
}
